import React from 'react';
import { Form } from 'react-form';
import { Input } from '../../Form';
import Popup from '../../Popup';
import styles from './removePlayerFromRosterPopUp.scss';

const RemovePlayerFromRosterPopUp = props => {
    const {
        onCloseClick,
        onCtaClick,
        playerId,
        playerName,
    } = props;
    const defaultValues = {
        playerId,
    };
    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.removePlayerFromRosterPopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
        >
            <div className={`${styles.section} pt0`}>
                <h4>
                    {`Remove ${playerName} From Roster`}
                </h4>
            </div>
            <div className={`${styles.section} pt0`}>
                <Form onSubmit={values => onCtaClick(values)} id="removePlayerFromRosterForm" defaultValues={defaultValues}>
                    {({ submitForm }) => {
                        return (
                            <form onSubmit={submitForm} id="removePlayerFromRosterForm">
                                <div className="row">
                                    <div className="col-12">
                                        <Input id="playerId" field={'playerId'} value={`${playerId}`} type="hidden" />
                                        <p>Are you sure you want to remove {playerName} from your team&apos;s roster? If so, please click &quot;Confirm&quot;.</p>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-12 col-md-6 mb16">
                                        <button
                                            onClick={onCloseClick}
                                            type="button"
                                            className="btn btn-default btn-xl text-uppercase btn-block"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-xl text-uppercase btn-block"
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        </Popup>
    );
};

export default RemovePlayerFromRosterPopUp;
